import type { RouteRecordRaw } from 'vue-router'
import { ADMIN_RBAC_PERMISSIONS } from '@/config/admin/rbac'

export const adminRiskRoutes: RouteRecordRaw[] = [
  {
    path: 'complaints',
    name: 'AdminComplaintList',
    component: () => import('@/views/admin/complaint/ComplaintListPage.vue'),
    meta: {
      title: '投诉处理',
      sidebarId: 'complaint-management',
      permissions: [ADMIN_RBAC_PERMISSIONS.COMPLAINT_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'complaints/:id',
    name: 'AdminComplaintDetail',
    component: () => import('@/views/admin/complaint/ComplaintDetailPage.vue'),
    meta: {
      title: '投诉详情',
      sidebarId: 'complaint-management',
      permissions: [ADMIN_RBAC_PERMISSIONS.COMPLAINT_VIEW],
      breadcrumb: true,
    },
  },
  {
    path: 'dispute/list',
    name: 'AdminDisputeList',
    component: () => import('@/views/admin/dispute/DisputeListPage.vue'),
    meta: {
      title: '争议仲裁',
      sidebarId: 'dispute-management',
      permissions: [ADMIN_RBAC_PERMISSIONS.COMPLAINT_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'dispute/:id',
    name: 'AdminDisputeDetail',
    component: () => import('@/views/admin/dispute/DisputeDetailPage.vue'),
    meta: {
      title: '争议详情',
      sidebarId: 'dispute-management',
      permissions: [ADMIN_RBAC_PERMISSIONS.COMPLAINT_VIEW],
      breadcrumb: true,
    },
  },
  {
    path: 'content/moderation',
    name: 'AdminContentModeration',
    component: () => import('@/views/admin/content/ContentModerationPage.vue'),
    meta: {
      title: '内容管控',
      sidebarId: 'content-moderation',
      permissions: [ADMIN_RBAC_PERMISSIONS.CONTENT_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'content/takedown-history',
    name: 'AdminTakedownHistory',
    component: () => import('@/views/admin/content/TakedownHistoryPage.vue'),
    meta: {
      title: '下架记录',
      sidebarId: 'takedown-history',
      permissions: [ADMIN_RBAC_PERMISSIONS.CONTENT_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
]
